import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_page_header = _resolveComponent("page-header")!

  return (_openBlock(), _createBlock(_component_page_header, { brand: _ctx.avoltaConnectLogo }, {
    actions: _withCtx(() => [
      _createVNode(_component_n_button_group, { class: "mr-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            size: "large",
            type: _ctx.filter === _ctx.DispatchDashboardFilterEnum.GAS ? 'primary' : 'default',
            tertiary: _ctx.filter !== _ctx.DispatchDashboardFilterEnum.GAS,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onFilter(_ctx.DispatchDashboardFilterEnum.GAS))),
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dispatch.header.select_filter.gas')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type", "tertiary"]),
          _createVNode(_component_n_button, {
            size: "large",
            type: _ctx.filter === _ctx.DispatchDashboardFilterEnum.TROUBLE ? 'primary' : 'default',
            tertiary: _ctx.filter !== _ctx.DispatchDashboardFilterEnum.TROUBLE,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onFilter(_ctx.DispatchDashboardFilterEnum.TROUBLE))),
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dispatch.header.select_filter.trouble')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type", "tertiary"]),
          _createVNode(_component_n_button, {
            size: "large",
            type: _ctx.filter === _ctx.DispatchDashboardFilterEnum.OFFLINE ? 'primary' : 'default',
            tertiary: _ctx.filter !== _ctx.DispatchDashboardFilterEnum.OFFLINE,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFilter(_ctx.DispatchDashboardFilterEnum.OFFLINE))),
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dispatch.header.select_filter.offline')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type", "tertiary"]),
          _createVNode(_component_n_button, {
            size: "large",
            type: _ctx.filter === _ctx.DispatchDashboardFilterEnum.OK ? 'primary' : 'default',
            tertiary: _ctx.filter !== _ctx.DispatchDashboardFilterEnum.OK,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFilter(_ctx.DispatchDashboardFilterEnum.OK))),
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dispatch.header.select_filter.ok')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type", "tertiary"]),
          _createVNode(_component_n_button, {
            size: "large",
            type: _ctx.filter === _ctx.DispatchDashboardFilterEnum.ALL ? 'primary' : 'default',
            tertiary: _ctx.filter !== _ctx.DispatchDashboardFilterEnum.ALL,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFilter(_ctx.DispatchDashboardFilterEnum.ALL))),
            round: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('dispatch.header.select_filter.all')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["type", "tertiary"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_n_button, {
        class: "mr-1",
        tertiary: "",
        round: "",
        size: "large",
        onClick: _ctx.refresh
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass([{spin: _ctx.isLoading}, "mdi mdi-refresh"])
          }, null, 2 /* CLASS */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["brand"]))
}